namespace RioERP.Enquiry {
    export interface EnquiryFollowupForm {
        Note: Serenity.StringEditor;
        FollowedBy: Serenity.LookupEditor;
        FollowUpDate: Serenity.DateEditor;
        FollowUpMode: Serenity.EnumEditor;
    }

    export class EnquiryFollowupForm extends Serenity.PrefixedContext {
        static formKey = 'Enquiry.EnquiryFollowup';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EnquiryFollowupForm.init)  {
                EnquiryFollowupForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DateEditor;
                var w3 = s.EnumEditor;

                Q.initFormType(EnquiryFollowupForm, [
                    'Note', w0,
                    'FollowedBy', w1,
                    'FollowUpDate', w2,
                    'FollowUpMode', w3
                ]);
            }
        }
    }
}
